import CustomAmplitudeClient from "./custom-amplitude-client.d4b698d00c77.js";
import"./backdrop-dialog.5d8ed14aed4b.js";

export class PriceVerification {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);

    document.addEventListener("click", (e) => {
      const button = e.target.closest(".price-verification");
      if (button) {
        const dataset = button.dataset;
        const page = dataset.page;
        const properties = {
          service_code: dataset.service,
          provider_id: dataset.providerid,
        };
        this.amplitudeClient.trackEngageVerifyPrice(page, properties);
        document.getElementById("price-verification-modal")?.showModal();
      }
    });
  }
}
